import { Project, ProjectFilter, ProjectPalette } from "./Projects";
import { Task, TaskFilter } from "./Tasks";
import { SubAPI } from "./SubAPI";

// feedSubscribePath is the websocket the live lists are served over (see FeedProvider)
export const feedSubscribePath = "/api/tasks/subscribe";

// the key is echoed back on the list that answers the subscription
export type TaskSubscription = {
    key: string;
    filter: TaskFilter;
}

export type ProjectSubscription = {
    key: string;
    filter: ProjectFilter;
}

export type Subscriptions = {
    subscriptions: TaskSubscription[];
    projectSubscriptions: ProjectSubscription[];
}

// FeedList answers one subscription. Only the list that was asked for is filled in.
export type FeedList = {
    key: string;
    tasks: Task[] | null;
    projects: Project[] | null;

    // how many tasks the filter matches, which is more than the list holds when only
    // a page of it was asked for
    total: number;
    error: string;
}

export type FeedSnapshot = {
    palette: ProjectPalette;
    lists: FeedList[];
}

export class Feed extends SubAPI {
    // read answers a set of subscriptions once, so a page has everything it opens
    // with after one request while the socket is still connecting
    read(props: Subscriptions) {
        return this.fetcher.post<FeedSnapshot>("/api/feed/read", props);
    }
}
